import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { BanafoModal, BifIconDownload, Button, Col, Form, LineSeparator, Row } from "banafo-design-system";
import { hideBulkDownloadModal, selectBulkDownloadModalIsOpen, selectSelectedIds, } from "src/features/conversations/conversationsSlice";
import { useBulkDownloadCallsMutation } from "src/features/conversations/conversationApi";
import { useState } from "react";
const formConfig = [
    { name: "title", get label() { return i18n.t('Title_'); } },
    { name: "summary", get label() { return i18n.t('Summary_'); } },
    { name: "tag", get label() { return i18n.t('Tag_'); } },
    { name: "compliance", get label() { return i18n.t('Compliance.score_'); } },
    { name: "action_points", get label() { return i18n.t('Action.points_'); } },
];
const BulkDownloadCallsModal = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const show = useSelector(selectBulkDownloadModalIsOpen);
    const selectedIds = useSelector(selectSelectedIds);
    const [bulkDownloadCalls] = useBulkDownloadCallsMutation({ fixedCacheKey: "bulk-download-recording" });
    const initialFormState = Object.fromEntries(formConfig.map(({ name }) => [name, true]));
    const [inputs, setInputs] = useState(initialFormState);
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setInputs(prev => (Object.assign(Object.assign({}, prev), { [name]: checked })));
    };
    const handleHideModal = () => {
        setInputs(initialFormState);
        dispatch(hideBulkDownloadModal());
    };
    const handleBulkDownloadCalls = () => {
        bulkDownloadCalls({ callIds: selectedIds, include: inputs })
            .unwrap()
            .catch(() => null)
            .finally(handleHideModal);
    };
    return (_jsxs(BanafoModal, { show: show, onHide: handleHideModal, title: t('Export.conversation_'), className: 'text-center', "aria-labelledby": "contained-modal-title-vcenter", children: [_jsx(LineSeparator, { color: 'dark', size: 2, className: "d-inline-block mt-100 mb-150", 
                // @ts-ignore
                style: { width: 150 } }), _jsx("p", { className: 'fw-bold text-danger mb-400', children: t('Select.what.conversation.data.to.include.in.the.exported.CSV_') }), _jsx(Form, { className: 'mb-400', children: formConfig.map(({ name, label }) => (_jsxs(Row, { className: "justify-content-between align-items-center", children: [_jsx(Form.Label, { column: true, xs: "auto", children: label }), _jsx(Col, { xs: "auto", children: _jsx(Form.Check, { type: "switch", inline: true, reverse: true, name: name, label: inputs[name] ? t('Yes_') : t('No_'), id: name, checked: inputs[name], onChange: handleCheckboxChange }) })] }, name))) }), _jsxs("div", { className: "d-flex justify-content-center", children: [_jsx(Button, { variant: 'outline-dark', className: 'text-uppercase mx-100', onClick: handleHideModal, children: t('Cancel_') }), _jsxs(Button, { variant: 'danger', className: 'text-uppercase mx-100 with-icon end', onClick: handleBulkDownloadCalls, children: [t('Export_'), " ", _jsx(BifIconDownload, {})] })] })] }));
};
export default BulkDownloadCallsModal;
